export const isCdkEnvironment = process.env.REACT_APP_WHITELABEL_NAME === 'cdk';
export const CAPTION = `WEBVTT`;
export const CAPTION_HEADER = `WEBVTT FILE`;
export const PLACEHOLDER = `{xazqby}`;
